import React from "react";
import { CheckCircle, XCircle, Info } from "lucide-react";
import MathRenderer from "../../../../common/MathRenderer";

const ResultIndicator = ({
  question,
  userAnswer,
  correctAnswer,
  isCorrect,
  isAnswer,
}) => {
  // Always show correct answer, even if user didn't answer
  if (!correctAnswer) return null;

  const formatCorrectAnswer = (answer, type) => {
    if (!answer) return "Không có đáp án đúng";

    switch (type) {
      case "TN":
        return answer;
      case "MA":
        if (Array.isArray(answer)) {
          return answer.join(", ");
        }
        return answer;
      case "DS":
        if (typeof answer === "object" && !Array.isArray(answer)) {
          return Object.entries(answer)
            .map(([key, value]) => `${key}: ${value}`)
            .join(", ");
        }
        return answer;
      case "TLN":
        if (Array.isArray(answer)) {
          return answer.join(" hoặc ");
        }
        return answer;
      case "TLN_M":
        if (typeof answer === "object" && !Array.isArray(answer)) {
          return Object.entries(answer)
            .filter(
              ([key, value]) =>
                value !== null && value !== undefined && value !== ""
            )
            .map(([key, value]) => `${key} ${value}`)
            .join(", ");
        }
        return answer;
      case "KT":
        if (typeof answer === "object" && !Array.isArray(answer)) {
          return Object.entries(answer)
            .filter(([key, value]) => value !== null && value !== undefined)
            .map(([key, value]) => `${key}: ${value}`)
            .join(", ");
        }
        return answer;
      default:
        if (Array.isArray(answer)) {
          return answer.join(" hoặc ");
        }
        return answer;
    }
  };

  return (
    <div className="mt-4 border-t border-gray-200 pt-4">
      {/* User Answer Result - Only show if user answered */}
      {userAnswer && (
        <div
          className={`flex items-start gap-3 p-4 rounded-lg mb-3 ${
            isCorrect
              ? "bg-green-50 border border-green-200"
              : "bg-red-50 border border-red-200"
          }`}
        >
          <div className="flex-shrink-0 mt-0.5">
            {isCorrect ? (
              <CheckCircle className="w-5 h-5 text-green-600" />
            ) : (
              <XCircle className="w-5 h-5 text-red-600" />
            )}
          </div>
          <div className="flex-1">
            <div
              className={`font-semibold text-sm ${
                isCorrect ? "text-green-800" : "text-red-800"
              }`}
            >
              {isCorrect ? "✓ Câu trả lời đúng" : "✗ Câu trả lời sai"}
            </div>
          </div>
        </div>
      )}

      {isAnswer && (
        <div className="flex items-start gap-3 p-4 rounded-lg bg-blue-50 border border-blue-200">
          <div className="flex-shrink-0 mt-0.5">
            <Info className="w-5 h-5 text-blue-600" />
          </div>
          <div className="flex-1">
            <div className="font-semibold text-sm mb-1 text-blue-800">
              💡 Đáp án đúng
            </div>
            <div className="text-sm text-blue-700">
              <span className="font-medium">Đáp án chính xác: </span>
              <span className="font-mono bg-white px-2 py-1 rounded border font-semibold text-blue-800">
                {formatCorrectAnswer(correctAnswer, question.type)}
              </span>
            </div>
          </div>
        </div>
      )}
      {/* Correct Answer - Always show for all questions */}
    </div>
  );
};

export default ResultIndicator;
